import { Injectable, NgZone } from "@angular/core";

import { ApplicationLoaderService } from "./application-loader.service";

@Injectable({
    providedIn: "root"
})
export class BrowserWindowService {
    private _initialUrl: string;

    public constructor(
        private _ngZone: NgZone
    ) {
        window.onpopstate = () => {
            this._ngZone.runOutsideAngular(() => ApplicationLoaderService.instance().reboot());
        };
    }

    // public getSiteUrl(): string {
    //     return window.location.href.split(/[?#]/)[0];
    // }

    public getQueryString(): string {
        const queryString: string = window.location.search;

        if (queryString && (queryString.length > 1)) {
            return queryString.slice(1);
        }

        return null;
    }

    public setQueryString(queryString: string): void {
        const currentUrl = window.location;
        const updatedUrl = [currentUrl.protocol, "//", currentUrl.host, currentUrl.pathname, "?", queryString].join("");

        if (currentUrl.href !== updatedUrl) {
            if (!this._initialUrl) {
                this._initialUrl = updatedUrl;
                window.history.replaceState({}, "", updatedUrl);
            } else {
                window.history.pushState({}, "", updatedUrl);
            }
        }
    }
}
